/* @flow */

import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import { useLocation } from "react-router";
import usePrevious from "helpers/hooks/use-previous";
import { NotificationBar } from "@crossroads/ui-components";
import Nav from "./Nav";
import { QuoteData, CmsBlockData } from "state/data";
import { useData } from "crustate/react";
import { useUi, MODE } from "helpers/ui";
import SystemMessages from "components/SystemMessages";

import styles from "./styles.scss";

const Header = (): React$Node => {
  const location = useLocation();
  const t = useTranslate();
  const { setHamburgerOpen, setSubNavOpen, setViewMode } = useUi();
  const quoteData = useData(QuoteData);
  const prevQuoteData = usePrevious(quoteData);
  const miniBannerData = useData(CmsBlockData);
  const [showMiniBanner, setShowMiniBanner] = useState(false);
  const onCheckout = (location ? location.pathname : "").includes("checkout");

  // Open mini cart when adding to cart
  useEffect(() => {
    if (location.pathname === t("URL.CHECKOUT_CART") ||
        !prevQuoteData ||
        (quoteData.state !== "LOADED" || prevQuoteData.state !== "ADDING_ITEM")) {
      return;
    }

    const count = quoteData.data.items.reduce((a, { qty }) => a + qty, 0);
    const prevCount = prevQuoteData.data.items.reduce((a, { qty }) => a + qty, 0);

    if (count > prevCount) {
      setViewMode(MODE.CART);
      setSubNavOpen(false);
      setHamburgerOpen(false);
    }
  }, [setViewMode, prevQuoteData, quoteData, location, setSubNavOpen, setHamburgerOpen]);

  useEffect(() => {
    if (
      miniBannerData.state === "LOADED" &&
      miniBannerData.data !== null &&
      miniBannerData.data.content !== ""
    ) {
      setShowMiniBanner(true);
    }
  }, [showMiniBanner, miniBannerData]);

  return (
    <>
      <header className={cn(styles.header, { [styles.onCheckout]: onCheckout })}>
        <SystemMessages />
        <Nav onCheckout={onCheckout} />
        {miniBannerData.state === "LOADED" && showMiniBanner && (
          <NotificationBar
            closeBtnTitle={t("NOTIFICATIONBAR.CLOSE")}
            className={styles.miniBanner}
            text={miniBannerData.data?.content}
            onClose={() => {}}
          />
        )}
      </header>
      <div
        className={cn(
          styles.placeholder,
          { [styles.headerBannerHeight]: showMiniBanner }
        )}
      />
    </>
  );
};

export default Header;
